// The axios response interceptor is registered once at module load in index.tsx, outside React,
// so it can't call into a context directly. SessionExpiredProvider registers its handler here and
// the interceptor reaches it through this bridge.

export type SessionExpiredOrigin = 'token-refresh' | 'token-configure' | 'token-get' | 'api-401';

type Handler = (origin: SessionExpiredOrigin) => void;

let handler: Handler | undefined;

export function registerSessionExpiredHandler(next: Handler) {
  handler = next;
  return () => {
    if (handler === next) handler = undefined;
  };
}

export function reportSessionExpired(origin: SessionExpiredOrigin) {
  handler?.(origin);
}
